import { CheckCircle2, ArrowRight } from "lucide-react";
import { IMAGES } from "../../data/content";
import { scrollToId } from "../../hooks/useSmoothScroll";
import { Reveal, Overline } from "./Reveal";
import BeforeAfterSlider from "./BeforeAfterSlider";

const POINTS = [
  "Gyorsabb, kevesebb bontási munkával járó megoldás",
  "Új, tartós és esztétikus tetőfedés",
  "A megfelelő technológia helyszíni felmérés alapján határozható meg",
];

export default function NoDemolition() {
  return (
    <section data-testid="no-demolition-section" className="relative overflow-hidden bg-[#0E5A75] py-16 sm:py-20 md:py-32">
      <div className="absolute inset-0 noise-overlay opacity-[0.12]" />
      <div className="pointer-events-none absolute -bottom-32 -right-20 h-[400px] w-[400px] rounded-full bg-emerald-500/15 blur-3xl" />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 px-5 md:px-10 items-center">
        <div>
          <Reveal><Overline light>Kiemelt szolgáltatás</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 text-4xl sm:text-5xl font-bold tracking-tight text-white text-balance">
              Régi tető felújítása bontás nélkül
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed">
              Bizonyos tetőtípusok esetében lehetőség van arra, hogy a meglévő fedés teljes
              elbontása nélkül újítsuk fel a tetőt. Ez gyorsabb, kevesebb bontási munkával járó
              megoldást jelenthet, miközben az épület új, tartós és esztétikus tetőfedést kap.
            </p>
          </Reveal>

          <ul className="mt-8 space-y-3">
            {POINTS.map((p, i) => (
              <Reveal key={i} delay={0.12 + i * 0.07}>
                <li className="flex items-start gap-3">
                  <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-400 mt-0.5" />
                  <span className="text-slate-200">{p}</span>
                </li>
              </Reveal>
            ))}
          </ul>

          <Reveal delay={0.3}>
            <button
              data-testid="no-demolition-cta"
              onClick={() => scrollToId("ajanlatkeres")}
              className="group mt-9 inline-flex items-center gap-2 rounded-full bg-[#0E5A75] px-7 py-4 text-base font-semibold text-white hover:bg-[#0E5A75] hover:scale-[1.03] transition-transform"
            >
              Megnézem, felújítható-e a tetőm bontás nélkül
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <BeforeAfterSlider before={IMAGES.beforeOld} after={IMAGES.afterNew} />
          <p className="mt-4 text-center text-sm text-slate-400">Húzza a csúszkát az összehasonlításhoz</p>
        </Reveal>
      </div>
    </section>
  );
}
